// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3lVQq","inputWrap":"Table_inputWrap__Dr32I","col":"Table_col__tEhk3","bmiTooltip":"Table_bmiTooltip__1ied2"};